import React from 'react';
import { Typography, Container, Paper } from '@mui/material';
import TablaSelecVul from '../componentes/PopUps/TablaSelecVul';
import TablaSelecAmenazas from '../componentes/PopUps/TablaAmenazas';
import TablaGA from '../componentes/PopUps/TablaGA';
import TablaSelecContramedidas from '../componentes/PopUps/TablaSelecContramedidas';

export const Activos = () => {
  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      <Typography variant="h5" fontWeight="600" sx={{ color: '#001F3F', mb: 3 }}>
        Gestión de Activos
      </Typography>
      <Paper sx={{ border: '1px solid #e0e0e0' }}>
        <TablaGA />
      </Paper>
    </Container>
  );
};

export const Vulnerabilidades = () => {
  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      <Typography variant="h5" fontWeight="600" sx={{ color: '#001F3F', mb: 3 }}>
        Gestión de Vulnerabilidades
      </Typography>
      <Paper sx={{ border: '1px solid #e0e0e0' }}>
        <TablaSelecVul />
      </Paper>
    </Container>
  );
};

export const Amenazas = () => {
  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      <Typography variant="h5" fontWeight="600" sx={{ color: '#001F3F', mb: 3 }}>
        Gestión de Amenazas
      </Typography>
      <Paper sx={{ border: '1px solid #e0e0e0' }}>
        <TablaSelecAmenazas />
      </Paper>
    </Container>
  );
};

export const Contramedidas = () => {
  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      <Typography variant="h5" fontWeight="600" sx={{ color: '#001F3F', mb: 3 }}>
        Gestión de Contramedidas
      </Typography>
      <Paper sx={{ border: '1px solid #e0e0e0' }}>
        <TablaSelecContramedidas />
      </Paper>
    </Container>
  );
};

